import { InvoiceType } from '../domain/types';

export const invoiceTypeLabels: Record<InvoiceType, string> = {
  [InvoiceType.MEDIATION]: 'Mediazione',
  [InvoiceType.PENALTY]: 'Penale',
  [InvoiceType.CREDIT_NOTE]: 'Nota di credito',
  [InvoiceType.EXTRA_PACKAGE]: 'Pacchetti Extra',
};
